// Frases positivas (para buenas calificaciones)
export const frasesPositivasEvaluacion = [
  "¡Excelente puntaje, eres un crack! 🏆✨",
  "Tu esfuerzo se refleja en tu calificación 💯👏",
  "¡Muy bien, alcanzaste un nivel sobresaliente! 🌟📈",
  "Tu dedicación te llevó a este gran resultado 🚀✅",
  "¡Impresionante, tu calificación habla por ti! 🧠🔥",
  "¡Felicitaciones, lograste un desempeño brillante! 🎊🌞",
  "Tu constancia dio frutos en esta nota 📝🌱",
  "¡Gran trabajo, tu calificación es ejemplar! 🥇📘",
  "¡Perfecto, alcanzaste la excelencia! 🌟🙌",
  "Tu puntaje refleja tu gran aprendizaje 📚💡"
];

// Frases negativas (para malas calificaciones)
export const frasesNegativasEvaluacion = [
  "No pasa nada, esta nota es solo un paso más 🔄🙂",
  "¡Ánimo, puedes mejorar tu calificación con práctica! 💪📘",
  "Tu esfuerzo vale, aunque el resultado no sea el esperado ❤️📉",
  "Equivocarse también enseña, sigue adelante 📚🤔",
  "¡No te desanimes, la próxima será mejor! 🌈✨",
  "Esta calificación no define tu potencial 🚀🙌",
  "¡Confía en ti, puedes subir tu puntaje! 🌟💡",
  "Cada error es una oportunidad de crecer 🌱📖",
  "¡Ánimo, tu constancia te llevará a mejores resultados! 🏆💪",
  "Lo importante es que sigas aprendiendo 📘🙂"
];
